<template>
  <div
    class="min-h-full bg-transparent text-slate-800 dark:text-[#F1F5F9] transition-colors duration-200"
  >
    <!-- Main Content -->
    <main class="max-w-7xl mx-auto px-2 sm:px-6 py-4 sm:py-6">
      <div
        class="relative bg-white dark:bg-[#111C30] rounded-2xl shadow-sm overflow-hidden border border-slate-200/80 dark:border-[#1E293B] h-screen max-h-[calc(100vh-170px)]"
      >
        <!-- Loading State -->
        <transition
          enter-active-class="transition-opacity duration-300"
          leave-active-class="transition-opacity duration-300"
          enter-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="loading"
            class="absolute inset-0 flex flex-col items-center justify-center bg-white/90 dark:bg-[#111C30]/90 z-30 backdrop-blur-sm"
          >
            <AppLoader
              variant="card"
              size="lg"
              message="Loading presentation..."
              subtext="Preparing interactive feature showcase"
              color="indigo"
              icon="sparkle"
            />
          </div>
        </transition>

        <!-- Iframe -->
        <iframe
          :src="embedUrl"
          frameborder="0"
          allowfullscreen="true"
          class="w-full h-full transition-opacity duration-500"
          :class="{
            'opacity-0 pointer-events-none': loading,
            'opacity-100': !loading,
          }"
          @load="onIframeLoad"
        ></iframe>
      </div>

      <!-- Footer Info -->
      <div
        class="hidden md:block mt-6 p-4 bg-white dark:bg-[#111C30] rounded-xl border border-slate-200/80 dark:border-[#1E293B] shadow-2xs"
      >
        <div class="flex items-center justify-between text-sm text-slate-600 dark:text-slate-400">
          <p>Interactive platform presentation view</p>
          <div class="flex items-center gap-2">
            <div
              class="w-2 h-2 rounded-full"
              :class="loading ? 'bg-amber-400 animate-pulse' : 'bg-emerald-500'"
            ></div>
            <span class="text-xs font-semibold">{{ loading ? "Loading..." : "Connected" }}</span>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
  import { ref } from "vue";

  const embedUrl = ref(
    "https://docs.google.com/presentation/d/1nWhufo8v0yziFEZ1Kn_QPnhkI_D0flXaLzhg5zmEDSM/embed?start=false&loop=false&delayms=3000",
  );

  const loading = ref(true);

  const onIframeLoad = () => {
    loading.value = false;
  };
</script>

<style scoped>
  /* Smooth animations */
  @keyframes subtle-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .animate-spin {
    animation: subtle-spin 2.5s linear infinite;
  }
</style>
